module.exports = __webpack_public_path__ + "img/INFINITI.ab8e6e7a.jpg";